export default __webpack_public_path__ + "static/media/arrow-down.4c24f2ce.svg";